import React from 'react';
import PropTypes from 'prop-types';
import '../../../assets/css/panel_plans.css';
import { Row, Col } from 'reactstrap';
import urlBase from '../../../../src/url-base';
import axios from 'axios';

class Plans extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      payment: null,
      planosAtivos: [],
      vededoresOrtomax: ["60db2529723a84336c5db4f0", "6130e3def501252ea56929e3", "5dd55301ee0313765bd2bc81"],
      
      // 🚀 Mapeamento Hardcoded temporário de planos exclusivos por vendedor
      // Substitua os IDs de exemplo pelos IDs reais do seu banco
      planosExclusivos: {
        "64d4c47f083cc84ce4f84ca4NHB": ["60db2529723a84336c5db4f0", "6130e3def501252ea56929e3",  "5dd55301ee0313765bd2bc81"], 
        "66912b1e5ba8489af4b3b759": ["60db2529723a84336c5db4f0", "6130e3def501252ea56929e3",  "5dd55301ee0313765bd2bc81"],
        "64d4c50c083cc84ce4f84ca5": ["60db2529723a84336c5db4f0", "6130e3def501252ea56929e3",  "5dd55301ee0313765bd2bc81"],  
        "64d4c58e083cc84ce4f84ca6": ["60db2529723a84336c5db4f0", "6130e3def501252ea56929e3",  "5dd55301ee0313765bd2bc81"],   
        "64d53ce634dcf81d2eab8af8": ["60db2529723a84336c5db4f0", "6130e3def501252ea56929e3",  "5dd55301ee0313765bd2bc81"],  
        "65240c3309cc0913269deae7": ["60db2529723a84336c5db4f0", "6130e3def501252ea56929e3",  "5dd55301ee0313765bd2bc81"] 

      }
    };
    
    this._isMounted = false;
  }
  componentDidUpdate(prevProps) {
  if (prevProps.isServidor !== this.props.isServidor) {       
        this.setState({ isServidor: this.props.isServidor }, () => {
          // Recarrega os planos caso a mudança de servidor influencie a busca da API
          this.carregarPlanos(this.props.isServidor)         
        });
      }
  }
  componentDidMount() {
    this.setState({ isServidor: this.props.isServidor }, () => {
      // Recarrega os planos caso a mudança de servidor influencie a busca da API
      this.carregarPlanos(this.props.isServidor)         
    });
        
    this._isMounted = true;
  
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  carregarPlanos (servidor) {
    var filtros = {"status":"ATIVO", "publish":true};
    if (servidor === true) 
        filtros = {"status":"ATIVO", "publish":true, "server" : true};
    var url = `${urlBase.loopBack}Plans?filter={"where":${JSON.stringify(filtros)}}`;
    //var url = urlBase.loopBack + 'Plans?filter={"where":filtros}';    
    axios.get(url)
      .then((response) => {
        if (this._isMounted) {
          this.setState({ planosAtivos: response.data });                  
        }
      })
      .catch((error) => {
        console.error(error);
        if (this._isMounted) {
          alert('Não foi possível localizar a tabela de preços do plano selecionado, entre em contato com o suporte!');
        }
      }); 
  }
  /*
  setValuePlan(id, paymentPlan, type, servidor) { 
    localStorage.setItem("dental_plan", id);
    localStorage.setItem("payment_plan", paymentPlan);
    localStorage.setItem("type_plan", type);
    localStorage.setItem("isServidor", servidor);
    if (this.props.onClickFn != null) {
      this.props.onClickFn();
    }
  }
  */
  
  setValuePlan(id, paymentPlan, type, servidor) { 
    // 1. Salvamentos originais
    localStorage.setItem("dental_plan", id);
    localStorage.setItem("payment_plan", paymentPlan);
    localStorage.setItem("type_plan", type);
    localStorage.setItem("isServidor", servidor);

    // 2. Lógica para capturar planos correlacionados
    const { planosAtivos } = this.state;
    const planoSelecionado = planosAtivos.find(plano => (plano.id || plano._id) === id);

    if (planoSelecionado) {
      const nomePlano = planoSelecionado.tradeName || planoSelecionado.name || '';
      const nomeUpper = nomePlano.trim().toUpperCase();

      // Identifica a terminação exata (SLZ ou SP)
      let sufixoCorrelacao = '';
      let ehRegional = false;

      if (nomeUpper.endsWith('SLZ')) {
        sufixoCorrelacao = 'SLZ';
        ehRegional = true;
      } else if (nomeUpper.endsWith('SP')) {
        sufixoCorrelacao = 'SP';
        ehRegional = true;
      }

      // Armazena os valores de referência do plano selecionado para comparação dos 3 campos
      const refTicket = planoSelecionado.ticket;
      const refServer = planoSelecionado.server;
      const refCard = planoSelecionado.card;

      // Filtra os planos com base nas regras
      const planosCorrelacionados = planosAtivos.filter(plano => {
        const nomeAtual = (plano.tradeName || plano.name || '').trim().toUpperCase();

        // 1. Regra dos 3 campos obrigatória para qualquer caso
        const mesmosCampos = 
          plano.ticket === refTicket && 
          plano.server === refServer && 
          plano.card === refCard;

        if (!mesmosCampos) {
          return false; 
        }

        // 2. Se o plano selecionado é SLZ ou SP, traz apenas os que terminam com esse mesmo sufixo
        if (ehRegional) {
          return nomeAtual.endsWith(sufixoCorrelacao);
        }

        // 3. Se o plano selecionado NÃO é SLZ nem SP, 
        // traz todos os planos que TAMBÉM não terminam em SLZ nem em SP
        const terminaComSlzOuSp = nomeAtual.endsWith('SLZ') || nomeAtual.endsWith('SP');
        return !terminaComSlzOuSp;
      });

      // Salva a lista completa na sessão
      localStorage.setItem("planos_correlacionados", JSON.stringify(planosCorrelacionados));
      
      //console.log("Planos correlacionados salvos na sessão:", planosCorrelacionados);
    }

    if (this.props.onClickFn != null) {
      this.props.onClickFn();
    }
  }
  payment(value) {
    this.setState({ payment: value });
  }

  // 🚀 Função para validar se o vendedor atual está autorizado para o plano
  vendedorPodeComercializar(planoId, vendedorId) {
    var regras = this.state.planosExclusivos;
    if (!regras[planoId]) {
      return true; // Sem restrições: qualquer vendedor pode ver
    }
    return regras[planoId].indexOf(vendedorId) !== -1;
  }

// Método auxiliar para filtrar os planos com base nas flags individuais
getPlanosFiltrados(dentalUser) {
  const { planosAtivos, payment, isServidor } = this.state;

  if (!planosAtivos) return [];

  return planosAtivos.filter(plano => {
    const idPlano = plano.id || plano._id;

    // 1. Validação de comercialização do vendedor
    if (!this.vendedorPodeComercializar(idPlano, dentalUser)) {
      return false;
    }

    // 2. Se a tela estiver no modo Servidor Público
    if (isServidor) {
      return plano.server === true; // Só mostra se o plano for comercializado para servidor
    }

    // 3. Se não for servidor, filtra pelo tipo de pagamento selecionado na aba
    if (payment === "CARTAO") {
      return plano.card === true;
    }

    if (payment === "BOLETO") {
      return plano.ticket === true;
    }

    return false;
  });
}

render() {
  const dentalUser = localStorage.getItem('dental_u') || '';
  const { payment, isServidor } = this.state;
  
  // Obtém a lista de planos filtrada dinamicamente pelas propriedades corretas
  const planosParaExibir = this.getPlanosFiltrados(dentalUser);

  return (
    <div>
      <Row style={{ marginTop: 40 }}>
        <Col md="3" lg="3" style={{ padding: 0 }} />  
        
        <Col xs="12" sm="12" md="6" lg="6" style={{ padding: 0 }}>
          
          {/* Cabeçalho do Painel */}
          <Row className="plans_family_panel">
            <Col xs="3" sm="3" md="3" lg="3" className="col_panel_family">
              <div className="plans_family_panel_icon"></div>
            </Col>
            <Col xs="9" sm="9" md="9" lg="9" style={{ padding: 0 }}>
              <div className="plans_family_text_panel">
                {isServidor ? "PLANO SERVIDOR" : "PLANO INDIVIDUAL OU FAMILIAR"}
              </div>
            </Col>
          </Row>

          {/* Seleção de Forma de Pagamento */}
          <Row className="plans_family_panel_mid">
            <Col xs={isServidor ? "12" : "6"} sm={isServidor ? "12" : "6"} md={isServidor ? "12" : "6"} lg={isServidor ? "12" : "6"} style={{ paddingLeft: 0, paddingRight: 2 }}>
              <div 
                onMouseOver={() => this.payment("CARTAO")} 
                className={payment === "CARTAO" ? "plans_family_panel_details_hover" : "plans_family_panel_details"}
              >
                {!isServidor ? "CARTÃO DE CRÉDITO" : "DESCONTO EM FOLHA"}
              </div>
            </Col>
            
            {!isServidor && (
              <Col xs="6" sm="6" md="6" lg="6" style={{ paddingLeft: 2, paddingRight: 0 }}>
                <div 
                  onMouseOver={() => this.payment("BOLETO")} 
                  className={payment === "BOLETO" ? "plans_family_panel_details_hover" : "plans_family_panel_details"}
                >
                  BOLETO
                </div>
              </Col>
            )}
          </Row>

          {/* Listagem Única dos Planos */}
          <Row 
            className="plans_family_panel_bottom"
            // Se for BOLETO, alinha o conteúdo à direita. Se não, alinha à esquerda.
            style={{ display: 'flex', justifyContent: !isServidor && payment === "BOLETO" ? 'flex-end' : 'flex-start' }}
          >
            <Col 
              xs="6" 
              sm="6" 
              md="6" 
              lg="6" 
              style={
                !isServidor && payment === "BOLETO" 
                  ? { paddingLeft: 0, paddingRight: 2 } // Ajuste de margem para o lado do Boleto
                  : { paddingLeft: 2, paddingRight: 0 } // Ajuste de margem para o lado do Cartão
              }
            >

              <div>
                {planosParaExibir.map((plano, index) => {
                  const idPlano = plano.id || plano._id;
                  
                  // Define dinamicamente o parâmetro do tipo (vip, super, etc.) baseado na aba ou se é servidor
                  let tipoPlano = "vip";
                  if (isServidor) {
                    tipoPlano = plano.type || "server_type"; // Defina o valor padrão para servidor aqui se necessário
                  } else if (payment === "BOLETO") {
                    tipoPlano = plano.type || "super";
                  }

                  return (
                    <span 
                      key={idPlano || index} 
                      onClick={() => this.setValuePlan(idPlano, payment === "CARTAO", tipoPlano, isServidor)}
                    >
                      <div className="choose_plan_panel_family">
                        {plano.tradeName || plano.name}
                      </div>
                    </span>
                  );
                })}
                
                {/* Mensagem de feedback caso não existam planos para o filtro selecionado */}
                {planosParaExibir.length === 0 && (
                  <div style={{ padding: 20, textAlign: 'center', color: '#999' }}>
                    Nenhum plano disponível para esta modalidade.
                  </div>
                )}
              </div>
            </Col>
          </Row>

        </Col>
      </Row>
    </div>
  );
}
}

Plans.defaultProps = {
  onClickFn: null
};

Plans.propTypes = {
  onClickFn: PropTypes.func
};

export default Plans;


/** WEBPACK FOOTER **
 ** ./src/components/Panel/ForYouAndYourFamily/Plans.js
 **/